export default function () {
  this.loadContent()
}
